import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { t } from 'i18next';
import { enqueueSnackbar } from 'notistack';

export const createCustomFetchBaseQuery = () => {
  const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const user = getState()?.user?.user;
      const token = user ? user.token : '';

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }

      return headers;
    },
  });

  // Return the custom base query with additional 401 handling logic
  return async (args, api, extraOptions) => {



    let result = await baseQuery(args, api, extraOptions);

    const checkPromoCode = result.meta?.request?.url?.includes('promo-code-click') && result.meta?.request?.method === 'PUT';

    if (result?.error && !checkPromoCode) {
      enqueueSnackbar(
        result?.error?.data?.message || result?.error?.data?.error || t('Something went wrong'),
        {
          variant: 'error',
        }
      );
    }

    if (result.error && result.error?.status === 401 || result.error?.status === 403) {
      enqueueSnackbar(
        result?.error?.data?.message || result?.error?.data?.error || t('something_went_wrong'),
        {
          variant: 'error',
        }
      );
      localStorage.clear();
      args?.url !== "/auth/login" && window.location.replace('/auth/login');
    }

    return result;
  };
};
